module.exports = __webpack_public_path__ + "img/fob_pin.6ff42fb9.svg";